// src/components/Hero.js - SIMPLER VERSION
import React, { useEffect, useRef, useState } from 'react';
import './Hero.css';

// SVG Icons
const ArrowRightIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

const SparklesIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .962 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.964 0z" />
  </svg>
);

const Hero = () => {
  const heroRef = useRef(null);
  const [showScrollIndicator, setShowScrollIndicator] = useState(true);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleMouseMove = (e) => {
      const { clientX, clientY } = e;
      const { innerWidth, innerHeight } = window;
      
      const moveX = (clientX - innerWidth / 2) / 50;
      const moveY = (clientY - innerHeight / 2) / 50;

      const elements = document.querySelectorAll('.parallax-element');
      elements.forEach((el, index) => {
        const speed = (index + 1) * 0.5;
        el.style.transform = `translate(${moveX * speed}px, ${moveY * speed}px)`;
      });
    };

    // Simple scroll handler with debounce
    const handleScroll = () => {
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      
      scrollTimeoutRef.current = setTimeout(() => {
        const scrollPosition = window.scrollY;
        const heroHeight = heroRef.current?.offsetHeight || 0;
        
        // Hide scroll indicator if scrolled more than 100px or if scrolled past hero section
        if (scrollPosition > 100 || scrollPosition > heroHeight * 0.3) {
          setShowScrollIndicator(false);
        } else {
          setShowScrollIndicator(true);
        }
      }, 50); // 50ms debounce
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('scroll', handleScroll);
    
    // Initial check
    handleScroll();
    
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('scroll', handleScroll);
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, []);

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
      setShowScrollIndicator(false);
    }
  };

  const scrollToServices = () => {
    const servicesSection = document.getElementById('services');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth' });
      setShowScrollIndicator(false);
    }
  };

  return (
    <section className="hero-section" id="home" ref={heroRef}>
      <div className="hero-background">
        <div className="gradient-orb orb-1 parallax-element"></div>
        <div className="gradient-orb orb-2 parallax-element"></div>
        <div className="gradient-orb orb-3 parallax-element"></div>
      </div>

      <div className="hero-content">
        <div className="hero-badge">
          <SparklesIcon />
          <span>Digital Excellence</span>
        </div>

        <h1 className="hero-title">
          <span className="title-line">Transforming Ideas</span>
          <span className="title-line">Into Digital</span>
          <span className="title-line highlight">Reality</span>
        </h1>

        <p className="hero-description">
          We create stunning digital experiences that drive results. From web development
          to branding, we're your partner in digital success.
        </p>

        <div className="hero-cta">
          <button className="btn-primary" onClick={scrollToContact}>
            Get Started
            <ArrowRightIcon />
          </button>
          <button className="btn-secondary" onClick={scrollToServices}>
            Our Services
          </button>
        </div>

        
      </div>

      {/* Show/Hide based on state */}
      {showScrollIndicator && (
        <div className="scroll-indicator">
          <div className="mouse">
            <div className="wheel"></div>
          </div>
          <p>Scroll to explore</p>
        </div>
      )}
    </section>
  );
};

export default Hero;